import { onMounted, onUnmounted, reactive } from "vue";

// 共享狀態，讓 Layout 可以直接讀取倒數秒數
export const refreshState = reactive({
  remainingSeconds: 0,
  active: false,
});

/**
 * 使用者閒置時自動重新取得資料，並更新共享倒數狀態
 * @param {Function} callback - 閒置時要執行的函數（例如 getData）
 * @param {number} idleMinutes - 閒置幾分鐘後觸發（預設 2）
 */
export function useAutoRefresh(callback, idleMinutes = 2) {
  let timer = null;
  let countdownInterval = null;
  let throttleTimer = null;

  const idleMs = idleMinutes * 60 * 1000;

  const startCountdown = () => {
    if (countdownInterval) clearInterval(countdownInterval);
    refreshState.remainingSeconds = idleMinutes * 60;

    countdownInterval = setInterval(() => {
      if (refreshState.remainingSeconds > 0) {
        refreshState.remainingSeconds--;
      }
    }, 1000);
  };

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
    startCountdown();

    timer = setTimeout(() => {
      callback();
      resetTimer();
    }, idleMs);
  };

  const onMouseMove = () => {
    if (throttleTimer) return;
    throttleTimer = setTimeout(() => {
      throttleTimer = null;
    }, 500);
    resetTimer();
  };

  const onActivity = () => {
    resetTimer();
  };

  onMounted(() => {
    refreshState.active = true;
    resetTimer();

    window.addEventListener("mousemove", onMouseMove, { passive: true });
    window.addEventListener("click", onActivity, { passive: true });
    window.addEventListener("keydown", onActivity, { passive: true });
    window.addEventListener("scroll", onActivity, { passive: true });
    window.addEventListener("touchstart", onActivity, { passive: true });
  });

  onUnmounted(() => {
    refreshState.active = false;
    refreshState.remainingSeconds = 0;

    if (timer) clearTimeout(timer);
    if (countdownInterval) clearInterval(countdownInterval);
    if (throttleTimer) clearTimeout(throttleTimer);

    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("click", onActivity);
    window.removeEventListener("keydown", onActivity);
    window.removeEventListener("scroll", onActivity);
    window.removeEventListener("touchstart", onActivity);
  });
}
